// Holiday Service - Provides information about upcoming holidays
export class HolidayService {
  constructor() {
    this.holidays = this.initializeHolidays();
  }

  initializeHolidays() {
    const currentYear = new Date().getFullYear();

    const holidays = [
      // Traditional Holidays
      {
        name: "New Year's Day",
        date: new Date(currentYear, 0, 1),
        type: "traditional",
        category: "Holiday",
      },
      {
        name: "Valentine's Day",
        date: new Date(currentYear, 1, 14),
        type: "traditional",
        category: "Holiday",
      },
      {
        name: "St. Patrick's Day",
        date: new Date(currentYear, 2, 17),
        type: "traditional",
        category: "Holiday",
      },
      {
        name: "Easter",
        date: this.getEasterDate(currentYear),
        type: "traditional",
        category: "Holiday",
      },
      {
        name: "Mother's Day",
        date: this.getNthWeekdayOfMonth(currentYear, 4, 0, 2),
        type: "traditional",
        category: "Holiday",
      },
      {
        name: "Memorial Day",
        date: this.getLastWeekdayOfMonth(currentYear, 4, 1),
        type: "traditional",
        category: "Holiday",
      },
      (() => {
        const fathersDayDate = this.getNthWeekdayOfMonth(currentYear, 5, 0, 3); // 3rd Sunday of June
        console.log(
          "[HolidayService] Father's Day calculated as:",
          fathersDayDate.toDateString()
        );
        return {
          name: "Father's Day",
          date: fathersDayDate,
          type: "traditional",
          category: "Holiday",
        };
      })(),
      {
        name: "Independence Day",
        date: new Date(currentYear, 6, 4),
        type: "traditional",
        category: "Holiday",
      },
      {
        name: "Labor Day",
        date: this.getNthWeekdayOfMonth(currentYear, 8, 1, 1),
        type: "traditional",
        category: "Holiday",
      },
      {
        name: "Halloween",
        date: new Date(currentYear, 9, 31),
        type: "traditional",
        category: "Holiday",
      },
      {
        name: "Thanksgiving",
        date: this.getNthWeekdayOfMonth(currentYear, 10, 4, 4),
        type: "traditional",
        category: "Holiday",
      },
      {
        name: "Christmas",
        date: new Date(currentYear, 11, 25),
        type: "traditional",
        category: "Holiday",
      },

      // Unique/Fun Holidays
      {
        name: "National Donut Day",
        date: this.getNthWeekdayOfMonth(currentYear, 5, 5, 1),
        type: "unique",
        category: "Food Holiday",
      },
      {
        name: "National Pizza Day",
        date: new Date(currentYear, 1, 9),
        type: "unique",
        category: "Food Holiday",
      },
      {
        name: "National Coffee Day",
        date: new Date(currentYear, 8, 29),
        type: "unique",
        category: "Food Holiday",
      },
      {
        name: "National Ice Cream Day",
        date: this.getNthWeekdayOfMonth(currentYear, 6, 0, 3),
        type: "unique",
        category: "Food Holiday",
      },
      {
        name: "Talk Like a Pirate Day",
        date: new Date(currentYear, 8, 19),
        type: "unique",
        category: "Fun Holiday",
      },
      {
        name: "National Hug Day",
        date: new Date(currentYear, 0, 21),
        type: "unique",
        category: "Fun Holiday",
      },
      {
        name: "National Dog Day",
        date: new Date(currentYear, 7, 26),
        type: "unique",
        category: "Pet Holiday",
      },
      {
        name: "National Cat Day",
        date: new Date(currentYear, 9, 29),
        type: "unique",
        category: "Pet Holiday",
      },
      {
        name: "World Kindness Day",
        date: new Date(currentYear, 10, 13),
        type: "unique",
        category: "Fun Holiday",
      },
      {
        name: "National Friendship Day",
        date: this.getNthWeekdayOfMonth(currentYear, 7, 0, 1),
        type: "unique",
        category: "Fun Holiday",
      },
      {
        name: "National Compliment Day",
        date: new Date(currentYear, 0, 24),
        type: "unique",
        category: "Fun Holiday",
      },
      {
        name: "Random Acts of Kindness Day",
        date: new Date(currentYear, 1, 17),
        type: "unique",
        category: "Fun Holiday",
      },
    ];

    return holidays;
  }

  // Helper function to calculate Easter date
  getEasterDate(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  }

  // Helper function to get nth weekday of month (e.g., 2nd Sunday)
  getNthWeekdayOfMonth(year, month, weekday, n) {
    const firstDay = new Date(year, month, 1);
    const firstWeekday = firstDay.getDay();
    const offset = (weekday - firstWeekday + 7) % 7;
    const date = 1 + offset + (n - 1) * 7;
    return new Date(year, month, date);
  }

  // Helper function to get last weekday of month
  getLastWeekdayOfMonth(year, month, weekday) {
    const lastDay = new Date(year, month + 1, 0);
    const lastWeekday = lastDay.getDay();
    const offset = (lastWeekday - weekday + 7) % 7;
    const date = lastDay.getDate() - offset;
    return new Date(year, month, date);
  }

  // Get holidays within the next N days
  getUpcomingHolidays(daysAhead = 3) {
    const today = new Date();
    const futureDate = new Date();
    futureDate.setDate(today.getDate() + daysAhead);

    return this.holidays
      .filter((holiday) => {
        const holidayDate = new Date(holiday.date);
        return holidayDate >= today && holidayDate <= futureDate;
      })
      .sort((a, b) => a.date - b.date);
  }

  // Get all holidays for the current year
  getAllHolidays() {
    return this.holidays.sort((a, b) => a.date - b.date);
  }

  // Get holidays by category
  getHolidaysByCategory(category) {
    return this.holidays.filter((holiday) => holiday.category === category);
  }

  // Get holidays by type (traditional or unique)
  getHolidaysByType(type) {
    return this.holidays.filter((holiday) => holiday.type === type);
  }

  // Check if today is a holiday
  getTodaysHolidays() {
    const today = new Date();
    return this.holidays.filter((holiday) => {
      const holidayDate = new Date(holiday.date);
      return holidayDate.toDateString() === today.toDateString();
    });
  }

  // Format date for display
  formatDate(date) {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }

  // Get days until holiday
  getDaysUntil(holidayDate) {
    const today = new Date();
    const holiday = new Date(holidayDate);
    const diffTime = holiday - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  }
}

// Create singleton instance
export const holidayService = new HolidayService();
